module.exports = __webpack_public_path__ + "media/images/vp/no.profile-ecd205600fb497e4f9aba371010b002b.png";